import React from 'react'
import PropTypes from 'prop-types'
import Dialog from 'material-ui/Dialog'

import Styles from './index.scss'

const ModalConfirmation = props => (
  <Dialog
    title="Are you sure to complete this project?"
    modal={false}
    open={props.open}
    onRequestClose={props.requestClose}
    contentStyle={{ textAlign: 'center', width: '400px' }}
  >
    <div>
      <button
        className={`${Styles.btn} ${Styles['btn-cancel']}`}
        onClick={props.requestClose}
      >
        Cancel
      </button>
      <button
        className={`${Styles.btn} ${Styles['btn-complete']}`}
        onClick={props.handleCompleteProject}
      >
        Complete
      </button>
    </div>
  </Dialog>
)

ModalConfirmation.propTypes = {
  open: PropTypes.bool.isRequired,
  requestClose: PropTypes.func.isRequired,
  handleCompleteProject: PropTypes.func.isRequired,
}

export default ModalConfirmation
